(function () {
  /* KCOD cart service fees (hidden fee products kept in sync with the cart).
     Two independent rules, each with its own fee product, trigger and quantity (always 1):
       residential   - ANY line whose "Address Type" property is residential.
       palletization - COMBINED quantity of lines carrying _kcod_pallet = 1 is 1-3 (SitOnIt lounge/table pieces).
                       0 or >= 4 qualifying pieces means no fee. One fee per order, never per line or per piece.
     Client-side only (Shopify Basic has no server-side fee hook): see docs/theme-customizations.md. */
  var RESIDENTIAL_ADDRESS_VALUES = [
    'Residential / Home address (may add freight)',
    'Residential / Home address (adds a $100 freight surcharge)'
  ];
  var PALLET_PROPERTY = '_kcod_pallet';
  var PALLET_MIN = 1;
  var PALLET_MAX = 3;
  var themeSettings = (window.theme && window.theme.settings) || {};
  var cartRoute = window.theme && window.theme.routes && window.theme.routes.cart;
  var isSyncing = false;

  function isFeeLine(item, variantId) {
    return !!item && !!variantId && Number(item.variant_id) === variantId;
  }

  function isAnyFeeLine(item) {
    return RULES.some(function (rule) { return isFeeLine(item, rule.variantId); });
  }

  function getAddressType(item) {
    if (!item || !item.properties) return '';
    return item.properties['Address Type'] || '';
  }

  function isResidentialLine(item) {
    if (!item || isAnyFeeLine(item)) return false;
    return RESIDENTIAL_ADDRESS_VALUES.indexOf(getAddressType(item)) !== -1;
  }

  function qualifyingQuantity(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      if (!item || isAnyFeeLine(item) || !item.properties) return sum;
      if (String(item.properties[PALLET_PROPERTY]) !== '1') return sum;
      return sum + (Number(item.quantity) || 0);
    }, 0);
  }

  var RULES = [
    {
      name: 'residential',
      variantId: Number(themeSettings.residential_fee_variant_id) || 0,
      autoProperty: '_residential_fee_auto',
      needed: function (cart) { return !!cart && !!cart.items && cart.items.some(isResidentialLine); }
    },
    {
      name: 'palletization',
      variantId: Number(themeSettings.pallet_fee_variant_id) || 0,
      autoProperty: '_kcod_pallet_fee_auto',
      needed: function (cart) {
        var qty = qualifyingQuantity(cart);
        return qty >= PALLET_MIN && qty <= PALLET_MAX;
      }
    }
  ];

  var activeRules = RULES.filter(function (rule) { return rule.variantId; });

  if (!activeRules.length || !cartRoute) {
    return;
  }

  function feeLinesFor(cart, rule) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) { return isFeeLine(item, rule.variantId); });
  }

  function fetchCart() {
    return window.fetch(cartRoute + '.js', {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to fetch cart');
      return response.json();
    });
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: cart },
      bubbles: true
    }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
      detail: { cart: cart },
      bubbles: true
    }));
  }

  function postCart(url, payload) {
    return window.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (body) {
          throw new Error('Unable to update cart: ' + response.status + ' ' + body);
        });
      }
      return response.json();
    });
  }

  /* One cart change for one rule, or null when that rule is already correct.
     Needed: exactly one fee line at quantity 1 (extra duplicate lines are zeroed first).
     Not needed: every fee line for that rule is removed. */
  function nextChange(cart, rule) {
    var lines = feeLinesFor(cart, rule);
    var needed = rule.needed(cart);

    if (!needed) {
      if (!lines.length) return null;
      return function () { return postCart(cartRoute + '/change.js', { id: lines[0].key, quantity: 0 }); };
    }
    if (!lines.length) {
      return function () {
        var properties = {};
        properties[rule.autoProperty] = 'true';
        return postCart(cartRoute + '/add.js', { items: [{ id: rule.variantId, quantity: 1, properties: properties }] });
      };
    }
    if (lines.length > 1) {
      return function () { return postCart(cartRoute + '/change.js', { id: lines[1].key, quantity: 0 }); };
    }
    if (Number(lines[0].quantity) !== 1) {
      return function () { return postCart(cartRoute + '/change.js', { id: lines[0].key, quantity: 1 }); };
    }
    return null;
  }

  function findPendingChange(cart) {
    for (var i = 0; i < activeRules.length; i += 1) {
      var change = nextChange(cart, activeRules[i]);
      if (change) return change;
    }
    return null;
  }

  /* Applies one change, refetches the cart, and repeats until both rules are satisfied (bounded so a
     misbehaving cart can never loop). The cart-change event fires once at the end. */
  function syncFees(cart) {
    if (!cart || isSyncing) return;
    if (!findPendingChange(cart)) return;

    isSyncing = true;
    var steps = 0;

    function step(current) {
      var change = findPendingChange(current);
      if (!change || steps >= 8) return current;
      steps += 1;
      return change().then(fetchCart).then(step);
    }

    Promise.resolve(step(cart))
      .then(function (finalCart) {
        notifyCartUpdated(finalCart);
      })
      .catch(function (error) {
        console.error('Cart fee sync failed', error);
      })
      .finally(function () {
        isSyncing = false;
      });
  }

  function syncFromStorefrontCart() {
    fetchCart().then(syncFees).catch(function (error) {
      console.error('Cart fee fetch failed', error);
    });
  }

  document.addEventListener('theme:cart:init', function (event) {
    if (event && event.detail && event.detail.cart) {
      syncFees(event.detail.cart);
      return;
    }
    syncFromStorefrontCart();
  });

  document.addEventListener('theme:cart:change', function (event) {
    if (!event || !event.detail || !event.detail.cart) return;
    syncFees(event.detail.cart);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromStorefrontCart);
  } else {
    syncFromStorefrontCart();
  }
})();

/* KCOD reveal-on-scroll (2026-10-26): progressive enhancement for [data-kcod-reveal] sections
   (kcod-feature-grid). Opacity/transform only, skipped for reduced motion, the theme editor and
   browsers without IntersectionObserver. Content is visible by default; a timeout reveals
   everything if the observer never fires. */
(function () {
  var roots = document.querySelectorAll('[data-kcod-reveal]');
  if (!roots.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  Array.prototype.forEach.call(roots, function (root) {
    var items = root.querySelectorAll('.kcod-fg__item');
    var pending = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(items, function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return; // already on screen: never hide it
      el.classList.add('is-pre');
      pending.push(el);
      io.observe(el);
    });
    if (pending.length) {
      setTimeout(function () {
        pending.forEach(function (el) { el.classList.add('is-in'); });
      }, 3000);
    }
  });
})();

/* KCOD collection guide strip (2026-10-31, first production use: Task Chairs): below 990px the panel is collapsed by CSS
   (html.js only, so there is no layout shift) and this toggles it. On wide screens the strip is always open and the
   heading button is inert. Without JS the strip stays fully visible. */
(function () {
  var strips = document.querySelectorAll('[data-kcod-cg-strip]');
  if (!strips.length || !window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 989px)');
  function sync() {
    Array.prototype.forEach.call(strips, function (box) {
      var btn = box.querySelector('.kcod-cg__toggle');
      if (!btn) return;
      if (mq.matches) {
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('tabindex');
        btn.setAttribute('aria-expanded', box.classList.contains('is-open') ? 'true' : 'false');
      } else {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }
  Array.prototype.forEach.call(strips, function (box) {
    var btn = box.querySelector('.kcod-cg__toggle');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (!mq.matches) return;
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
})();

/* KCOD 2026-11-02 card fix A: the product-card slide dots are decorative and are generated by
   Pipeline's theme.js (ProductGridItemVariant.createPaging). Their numbers leaked into the product image link's accessible
   name ("1 2 3 4 5 6 7 ..."). Mark them aria-hidden without patching the vendor bundle. */
(function () {
  var SEL = '.product-grid-item__pagination';
  function hide(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll(SEL), function (el) {
      if (el.getAttribute('aria-hidden') !== 'true') el.setAttribute('aria-hidden', 'true');
    });
  }
  function run() {
    hide(document);
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        Array.prototype.forEach.call(r.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SEL)) n.setAttribute('aria-hidden', 'true');
          else hide(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

